import { type ReactNode } from 'react'
import Image from 'next/image'
import { cn } from '@/lib/utils'

type VerdictProps = {
  total: number
  children: ReactNode
}

export default function Verdict({ total, children }: VerdictProps) {
  return (
    <div className="relative z-20 flex">
      <Image
        src="/img/best/laurel-left.svg"
        alt=""
        aria-hidden="true"
        width={240}
        height={480}
        className={cn(
          'absolute left-0 z-10 hidden -translate-x-[125px] lg:-translate-x-[150px]',
          total < 3 ? 'md:block' : 'xl:block',
        )}
      />
      <div className="relative z-20 flex flex-col gap-5 sm:flex-row">{children}</div>
      <Image
        src="/img/best/laurel-right.svg"
        alt=""
        aria-hidden="true"
        width={240}
        height={480}
        className={cn(
          'absolute right-0 z-10 hidden translate-x-[125px] lg:translate-x-[150px]',
          total < 3 ? 'md:block' : 'xl:block',
        )}
      />
    </div>
  )
}
